export enum NoteCommentsSocketEventType {
  COMMENT_CREATE = 'comments:commentCreated',
  COMMENT_UPDATE = 'comments:commentUpdated',
  COMMENT_REMOVE = 'comments:commentDeleted',
  COMMENT_READ = 'noteComment:read',
  COMMENT_READ_V2 = 'comments:commentsRead',
  COMMENT_MENTION = 'noteComment:mention',
  THREAD_CREATE = 'comments:threadCreated',
  THREAD_UPDATE = 'comments:threadUpdated',
  THREAD_REMOVE = 'comments:threadDeleted',
}

export interface GetCommentThreadPayload {
  userId: number;
  workspaceId: string;
  threadId: string;
}

export declare const CommentThreadTargetEnum: {
  readonly Text: 'text';
  readonly Blot: 'blot';
  readonly ImagePoint: 'image-point';
  readonly Task: 'task';
  readonly Cell: 'cell';
};
export type CommentThreadTargetEnum = (typeof CommentThreadTargetEnum)[keyof typeof CommentThreadTargetEnum];
export interface CommentThread {
  globalId: string;
  orgId: string;
  userId: number;
  target: CommentThreadTargetEnum;
  targetId: string;
  attributes: object;
  createdAt: number;
  updatedAt: number;
  resolvedAt?: number | null;
}
